import React from 'react';
import externalLinks from '../../../../config/external-links.json';
import {
    LkNalogStep1,
    LkNalogStep2,
    LkNalogStep3,
    LkNalogStep4,
    EpnStep1,
    EpnStep2,
    EpnStep3,
    EpnStep4,
} from './images';

export const getNalogRegistrationSteps = t => ({
    textPosition: 'bottom', // or 'left' (self-employed)
    withArrows: true,
    type: 'narrow', // or 'wide' (tg bot)
    steps: [
        {
            img: LkNalogStep1,
            caption: (
                <>
                    {t('Indicate the phone number that you use')}
                    <br />
                    <a
                        className="underline text-blueGray-800"
                        href={externalLinks.nalogApp}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t('Other ways to register')}
                    </a>
                </>
            ),
        },
        {
            img: LkNalogStep2,
            caption: t('Indicate the region in which you carry out your activities'),
        },
        {
            img: LkNalogStep3,
            caption: t('Enter your INN'),
        },
        {
            img: LkNalogStep4,
            caption: t('Protect the application with a pin code'),
        },
    ],
});

export const getEpnRegistrationSteps = t => ({
    textPosition: 'bottom',
    type: 'narrow',
    withArrows: true,
    steps: [
        {
            img: EpnStep1,
            caption: t('Choose “New sale“'),
        },
        {
            img: EpnStep2,
            caption: t('Enter the amount of earnings that you receive'),
        },
        {
            img: EpnStep3,
            caption: t('Choose the option “Legal entity or individual entrepreneur“'),
        },
        {
            img: EpnStep4,
            caption: t('Issue the check'),
        },
    ],
});
